import React, { useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import styled from "styled-components";
import { chooseToken } from "../../../utils";






  const CouponInput = styled.input`
  
  display:flex;
  justify-content:center;
  align-items:center;
  width:100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  outline: none;
  border-radius: 4px;
 font-size: 1rem;
 font-family: 'Ancizar Sans', sans-serif;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border:1px solid rgba(73, 73, 73, 0.26);
  margin-top: 1rem;



  `

const CheckoutPriceDetailsNew = (props) => {
  const { cartPriceDetail = {}, shipmentsLen = 0,handleApplyCoupon={} } = props;
  const [couponValue, setCouponValue] = useState("");
  



  const {
     price=0,
       discount=0,
        shippingFee=0,
        discountedShippingFee=0,
        totalAmount=4355,
        couponDiscount=0,
        gstAmount=0,
        subtotal=0,
        shippingFeeTax=0,
  } = cartPriceDetail;


  const CartPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    min-height: 200px;
    min-width: 300px;
    background-color: #fff;
    padding: 1rem 1.4rem;


    @media (max-width: 900px) {

    margin-top:1rem;
    width: 94vw;


}

  


  `

  const CartPrice = styled.div`
    font-size: .9rem;
    color: rgb(130, 130, 130);
    text-align: left;   
    font-weight: 500;
    padding: .5rem 1px;
    margin-bottom: .5rem;

  `
  const PriceDetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: .2rem 1px;

    span:first-child {
      font-size: .85rem;
      color: rgb(130, 130, 130);
    }
    span:last-child {
      font-size: .85rem;
      color: rgb(126, 126, 126);
      font-weight: 500;
    }
   
  `
    const PriceDetailRowLast = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: .2rem 1px;
  

    span:first-child {
      font-size: .85rem;
      color: rgb(130, 130, 130);
    }
    span:last-child {
      font-size: .85rem;
      color: rgb(65, 65, 65);
      font-weight: 500;
    }
   
  `

const ApplyButton = styled.button`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 35px;
background-color: rgb(128, 211, 39);
color: #fff;
outline: none;
border-radius: 4px;
margin-top: 0.5rem;
border: none;
cursor: pointer;

`
  const handleCouponChange = (e) => {
    setCouponValue(e.target.value);
  }




  return (
  <>
       <CartPriceContainer>
        <CartPrice>
            PRICE DETAILS
        </CartPrice>
        <PriceDetailRow>
            <span>{`Price (${shipmentsLen} items)`}</span>
            <span>{`₹${price}`}</span>
        </PriceDetailRow>
         <PriceDetailRow>
            <span>{`Discount`}</span>
            <span style={{color:'#388012',fontWeight:'800'}} >{`-₹${discount}`}</span>
        </PriceDetailRow>
          <PriceDetailRow >
            <span>{`Subtotal`}</span>
            <span>{`₹${subtotal}`}</span>
        </PriceDetailRow>
            <PriceDetailRow >
            <span>{`Shipping`}</span>
            <span>{`₹${shippingFee}`}</span>
        </PriceDetailRow>
          <PriceDetailRow >
            <span>{`Shipping Fee Tax`}</span>
            <span>{`₹${shippingFeeTax}`}</span>
        </PriceDetailRow>
          {couponDiscount > 0 && <>
           <PriceDetailRow >
            <span>{`Coupon Discount`}</span>
            <span style={{color:'#388012',fontWeight:'800'}} >{`-₹${couponDiscount}`}</span>
        </PriceDetailRow>
          
          </>}

    
        <PriceDetailRow style={{borderBottom: "1px solid rgba(0, 0, 0, 0.12)"}}>
            <span>{`Goods and Service Tax`}</span>
            <span>{`₹${gstAmount}`}</span>
        </PriceDetailRow>
         
        <PriceDetailRowLast>
            <span>{`Total Amount`}</span>
            <span style={{color:'#555',fontWeight:'800'}}>{`₹${totalAmount}`}</span>
        </PriceDetailRowLast>

     </CartPriceContainer>

     <div style={{marginTop:'1rem',fontSize:'.9rem',color:'#888',display:'flex',flexDirection:'column',gap:'.5rem',backgroundColor:'#fff',padding:'1rem',borderRadius:'8px',width:'297px'}}>
      <p style={{fontSize:'.9rem',margin:0}}>Minimun Cart value needs to be ₹1000(excluding tax and shipping charges)</p>
       <p style={{fontSize:'.9rem',margin:0}}>Max Value of Coupon Discount is ₹500</p>
        <p style={{fontSize:'.9rem',margin:0}}>this coupon is valid for a limited time only</p>
     </div>

     <CouponInput type="text" value={couponValue} placeholder="Enter Coupon Code" onChange={handleCouponChange}>

     </CouponInput>

      <ApplyButton onClick={() => handleApplyCoupon(couponValue)}>
          Apply Coupon 
      </ApplyButton>
     </>
  );
};

export default CheckoutPriceDetailsNew;
